import { AppBar } from "./components";

/** Figma 527:124 — "Hang tight!" shown while account data loads. */
export function LoadingScreen() {
  return (
    <div className="mx-auto flex min-h-screen w-full max-w-[390px] flex-col bg-white">
      <AppBar />
      <div className="flex h-[280px] items-center justify-center overflow-hidden">
        <img
          src="/brand/onboarding/kit-box.png"
          alt=""
          className="h-[260px] w-[340px] object-cover"
        />
      </div>
      <div className="flex flex-col gap-4 px-8 pt-3 pb-12 text-center">
        <h1 className="text-primary type-title">Hang tight!</h1>
        <p className="text-muted text-[17px] leading-6">
          We&apos;re loading your account information. This will only take a moment.
        </p>
      </div>
      <div className="flex flex-col items-center gap-5">
        <div
          className="border-accent size-12 animate-spin rounded-full border-4 border-t-transparent"
          role="status"
        >
          <span className="sr-only">Loading</span>
        </div>
        <p className="text-muted text-[15px] leading-[22px]">Fetching your kit details…</p>
      </div>
    </div>
  );
}
